$(document).on("click",".product__color-swatches--inner .product__color-swatch",function() {
  setTimeout(function() {
    fetch(`${window.location.href}`).then((response) => {
      return response.text();
    })
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html').querySelectorAll('.dynamic-variant-input-wrap button');
      var variants = $('.dynamic-variant-input-wrap button');

      for (let i = 0; i < variants.length; i++) {
        var has_disabled = false;
        if($($('.dynamic-variant-input-wrap button')[i]).hasClass('disabled')){
          var has_disabled = true;
        }
        $($('.dynamic-variant-input-wrap button')[i]).removeAttr('class');
        $($('.dynamic-variant-input-wrap button')[i]).addClass(html[i].className);
        if(has_disabled){
          $($('.dynamic-variant-input-wrap button')[i]).addClass('disabled');
        }
        $($('.dynamic-variant-input-wrap button')[i]).html(html[i].innerHTML);
      }
    })
    .catch(e => {
      console.error(e);
    })
    .finally(() => {
    });
  }, 50);
});